import React from 'react';
import AccountBalanceIcon from '@mui/icons-material/AccountBalance';
import PeopleIcon from '@mui/icons-material/People';
import AttachMoneyIcon from '@mui/icons-material/AttachMoney';
import BusinessCenterIcon from '@mui/icons-material/BusinessCenter';
import RemoveCircleOutlineIcon from '@mui/icons-material/RemoveCircleOutline';
import SwapHorizIcon from '@mui/icons-material/SwapHoriz';
import AddBoxIcon from '@mui/icons-material/AddBox';
import SearchIcon from '@mui/icons-material/Search';
import ConfirmationNumberIcon from '@mui/icons-material/ConfirmationNumber';
import InventoryIcon from '@mui/icons-material/Inventory';
import BuildIcon from '@mui/icons-material/Build';
import DashboardIcon from '@mui/icons-material/Dashboard';
import MenuBookIcon from '@mui/icons-material/MenuBook';
import BarChartIcon from '@mui/icons-material/BarChart';
import StorageIcon from '@mui/icons-material/Storage';
import FeedbackIcon from '@mui/icons-material/Feedback';
import NotificationsIcon from '@mui/icons-material/Notifications';

let dynamicIndex = 1;

export const pages = [
  //Admin Sidenav
  {
    title: "Notifications",
    href: "/management/notifications",
    visible: true,
    index: dynamicIndex++,
    authorized: ["super_admin", "museum_chief", "curator", "assistant", "receptionist", "conservator", "interns", "volunteers"],
    icon: <NotificationsIcon />,
  },
  {
    title: "Museums",
    href: "/management/museums",
    visible: true,
    index: dynamicIndex++,
    authorized: ["super_admin", "museum_chief"],
    icon: <AccountBalanceIcon />,
  },
  {
    title: "User",
    href: "/management/users",
    visible: true,
    index: dynamicIndex++,
    authorized: ["super_admin", "museum_chief"],
    icon: <PeopleIcon />,
  },
  {
    title: "Set Fee",
    href: "/management/fee",
    visible: false,
    index: dynamicIndex++,
    authorized: ["super_admin", "museum_chief"],
    icon: <AttachMoneyIcon />,
  },
  {
    title: "Loan",
    href: "/management/loan",
    visible: true,
    index: dynamicIndex++,
    authorized: ["super_admin", "museum_chief"],
    icon: <BusinessCenterIcon />,
  },
  {
    title: "Deaccession",
    href: "/management/deaccession",
    visible: true,
    index: dynamicIndex++,
    authorized: ["super_admin", "museum_chief"],
    icon: <RemoveCircleOutlineIcon />,
  },
  {
    title: "Transfer",
    href: "/management/transfer-list",
    visible: true,
    index: dynamicIndex++,
    authorized: ["super_admin", "museum_chief"],
    icon: <SwapHorizIcon />,
  },
  {
    title: "Acquisition",
    href: "/management/acquisition",
    visible: true,
    index: dynamicIndex++,
    authorized: ["super_admin", "museum_chief"],
    icon: <AddBoxIcon />,
  },

  //Curator
  {
    title: "User Management",
    href: "/management/user-management",
    visible: true,
    index: dynamicIndex++,
    authorized: ["curator"],
    icon: <PeopleIcon />,
  },

  //Museum Assistant
  {
    title: "Acquisition",
    href: "/management/acquisition",
    visible: true,
    index: dynamicIndex++,
    authorized: ["assistant"],
    icon: <AddBoxIcon />,
  },

  //Volunteers / interns
  {
    title: "Catalogue Artefacts",
    href: "/management/catalogue-artefacts",
    visible: true,
    index: dynamicIndex++,
    authorized: ["interns", "volunteers"],
    icon: <SearchIcon />,
  },

  {
    title: "Catalog",
    href: "/management/catalogue-artefacts",
    visible: true,
    index: dynamicIndex++,
    authorized: ["curator", "assistant","super_admin", "museum_chief"],
    icon: <SearchIcon />,
  },
  {
    title: "Ticket",
    href: "/management/fd-dashboard",
    visible: true,
    index: dynamicIndex++,
    authorized: ["assistant", "curator", "super_admin", "museum_chief"],
    icon: <ConfirmationNumberIcon />,
  },

  {
    title: "Artifact Management",
    href: "/management/artifact-managements",
    visible: true,
    index: dynamicIndex++,
    authorized: ["curator"],
    icon: <InventoryIcon />,
  },

  //Conservator
  {
    title: "Conserve Artefacts",
    href: "/management/conservator",
    visible: true,
    index: dynamicIndex++,
    authorized: ["conservator"],
    icon: <BuildIcon />,
  },

  //Receptionist
  {
    title: "Ticket",
    href: "/management/fd-dashboard",
    visible: true,
    index: dynamicIndex++,
    authorized: ["receptionist"],
    icon: <DashboardIcon />,
  },
  {
    title: "Temporary Exhibition",
    href: "/management/temporary-exhibition",
    visible: true,
    index: dynamicIndex++,
    authorized: ["assistant", "receptionist"],
    icon: <ConfirmationNumberIcon />,
  },
  {
    title: "Research Materials",
    href: "/management/research-material",
    visible: true,
    index: dynamicIndex++,
    authorized: ["super_admin", "museum_chief", "curator"],
    icon: <MenuBookIcon />,
  },
  {
    title: "Reports",
    href: "/management/reports",
    visible: true,
    index: dynamicIndex++,
    authorized: ["super_admin", "museum_chief", "curator"],
    icon: <BarChartIcon />,
  },
  {
    title: "Master Data",
    href: "/management/master-data",
    visible: true,
    index: dynamicIndex++,
    authorized: ["super_admin", "museum_chief"],
    icon: <StorageIcon />,
  },
  {
    title: "Ticket Management",
    href: "/management/ticket-management",
    visible: true,
    index: dynamicIndex++,
    authorized: ["super_admin", "museum_chief", "curator"],
    icon: <ConfirmationNumberIcon />,
  },
  {
    title: "Feedback",
    href: "/management/feedback",
    visible: true,
    index: dynamicIndex++,
    authorized: ["super_admin", "museum_chief"],
    icon: <FeedbackIcon />,
  },
];
